import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    name: 'index',
    component: (resolve) => require(['@/views/main'], resolve),
    children: [
      {
        path: 'home',
        redirect: '/',
      },
      {
        path: '/',
        name: 'home',
        component: (resolve) => require(['@/views/home/home'], resolve),
      },
      {
        path: 'news',
        name: 'news',
        component: (resolve) => require(['@/views/news/index'], resolve),
      },
      {
        path: 'case',
        name: 'case',
        component: (resolve) => require(['@/views/case/index'], resolve),
      },
      {
        path: 'product',
        name: 'product',
        component: (resolve) => require(['@/views/product/index'], resolve),
      },
      {
        path: 'solution',
        name: 'solution',
        component: (resolve) => require(['@/views/solution/index'], resolve),
      },
      {
        path: 'platform',
        name: 'platform',
        component: (resolve) => require(['@/views/platform/index'], resolve),
      },
      {
        path: 'about',
        name: 'about',
        component: (resolve) => require(['@/views/about/index'], resolve),
      },
      {
        path: 'search',
        name: 'search',
        component: (resolve) => require(['@/views/search/index'], resolve),
      }
    ]
  },
  {
    path: '*', // 404 页面
    component: (resolve) => require(['@/components/404'], resolve),
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export default router

router.beforeEach((to, from, next) => {
  next()
})


// WEBPACK FOOTER //
// ./src/router/index.js